import './index.css'

const AboutCovidFactList = props => {
  const {banner} = props

  return (
    <>
      <li className="AboutCovidFactList">{banner}</li>
    </>
  )
}

export default AboutCovidFactList
